export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_13.a749a57d.jpg";